import React from "react";
import { Box, Typography } from "@mui/material";
import { DisplayPreferences } from "../../hooks/useTenantDisplayPreferences";
import { getOwnershipStatusLabel } from "../../constants/ownershipStatus";

type OwnershipDisplayLinesProps = {
  preferences: DisplayPreferences;
  ownershipStatus?: number | null;
  ownershipStatusLabel?: string | null;
  owner?: string | null;
  operatorName?: string | null;
  /** When false, nothing is rendered (e.g. component installed on airframe). */
  visible?: boolean;
  showOperator?: boolean;
  sectionTitle?: string;
};

export const OwnershipDisplayLines: React.FC<OwnershipDisplayLinesProps> = ({
  preferences,
  ownershipStatus,
  ownershipStatusLabel,
  owner,
  operatorName,
  visible = true,
  showOperator = false,
  sectionTitle,
}) => {
  if (!visible) return null;

  const statusLabel = getOwnershipStatusLabel(
    ownershipStatus,
    ownershipStatusLabel
  );
  const displayStatusLabel = statusLabel?.trim() ? statusLabel : "N/A";
  const displayOperatorName = operatorName?.trim() ? operatorName : "N/A";
  const showStatus = preferences.showOwnershipStatus;
  const showOwner = preferences.showOwner && owner?.trim();
  const showOp = showOperator && preferences.showOperator;

  if (!showStatus && !showOwner && !showOp) return null;

  return (
    <Box sx={{ mt: sectionTitle ? 0 : 1 }}>
      {sectionTitle && (
        <Typography
          variant="subtitle1"
          sx={{ color: "hsl(19 101% 51% / 1)", mt: 2, mb: 1 }}
        >
          {sectionTitle}
        </Typography>
      )}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 1,
          fontSize: "0.9rem",
        }}
      >
      {showOp && (
        <Typography sx={{ color: "#ccc" }}>
          <Box component="span" sx={{ color: "hsl(19 101% 51% / 1)", fontWeight: 600 }}>
            Operator:{" "}
          </Box>
          {displayOperatorName}
        </Typography>
      )}
      {showOwner && (
        <Typography sx={{ color: "#ccc" }}>
          <Box component="span" sx={{ color: "hsl(19 101% 51% / 1)", fontWeight: 600 }}>
            Owner:{" "}
          </Box>
          {owner}
        </Typography>
      )}
      {showStatus && (
        <Typography sx={{ color: "#ccc", gridColumn: { sm: showOp && showOwner ? "1 / -1" : undefined } }}>
          <Box component="span" sx={{ color: "hsl(19 101% 51% / 1)", fontWeight: 600 }}>
            Ownership Status:{" "}
          </Box>
          {displayStatusLabel}
        </Typography>
      )}
      </Box>
    </Box>
  );
};
